import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// TD3-122: Load hard deletion test utilities in development
if (process.env.NODE_ENV === 'development') {
  import('./utils/testHardDelete');
}

const root = ReactDOM.createRoot(document.getElementById('root'));

// Disable StrictMode for API calls to prevent double billing
// StrictMode intentionally double-invokes effects in development
const AppWrapper = process.env.NODE_ENV === 'development' && process.env.REACT_APP_ENV_MODE !== 'production'
  ? ({ children }) => <React.StrictMode>{children}</React.StrictMode>
  : ({ children }) => children;

root.render(
  <AppWrapper>
    <App />
  </AppWrapper>
);